import { useEffect, useState } from 'react';

import getRemoteSettings from '@/utils/user/getRemoteSettings';

interface HomeLayoutExperimentSetting {
  enabled: boolean;
  itemsPerRow: number;
}

const REMOTE_SETTING_NAME = 'genai_studio_home_layout_ab';

const DEFAULT_SETTING: HomeLayoutExperimentSetting = {
  enabled: true,
  itemsPerRow: 6,
};

const isHomeLayoutExperimentSetting = (
  settings: unknown
): settings is HomeLayoutExperimentSetting =>
  typeof settings === 'object' &&
  settings !== null &&
  typeof (settings as HomeLayoutExperimentSetting).enabled === 'boolean' &&
  typeof (settings as HomeLayoutExperimentSetting).itemsPerRow === 'number';

let cachedValue: HomeLayoutExperimentSetting | undefined;

const useHomeLayoutExperiment = (): {
  isCardRowLayout: boolean;
  itemsPerRow: number;
} => {
  const [setting, setSetting] = useState<HomeLayoutExperimentSetting>(
    cachedValue ?? DEFAULT_SETTING
  );

  useEffect(() => {
    if (cachedValue !== undefined) return;
    getRemoteSettings<HomeLayoutExperimentSetting>({
      name: REMOTE_SETTING_NAME,
      tag: REMOTE_SETTING_NAME,
      defaultValue: DEFAULT_SETTING,
      validate: isHomeLayoutExperimentSetting,
    }).then((value) => {
      cachedValue = value;
      setSetting(value);
    });
  }, []);

  return {
    isCardRowLayout: setting.enabled,
    itemsPerRow: setting.itemsPerRow,
  };
};

export default useHomeLayoutExperiment;
